// extracted by mini-css-extract-plugin
export default {"container":"styles-module__container__src-labstep-web-components-ResourceItem-Form-ShowEdit-ResourceLocation-_oDrnp"};